/**
 * AuthCard — shared layout for auth screens.
 *
 * Centered card on desktop; full-screen on mobile (design spec: 05-auth).
 * Handles the outer chrome (logo, card border). Individual screens render
 * their form content as children.
 */

import React from 'react';

interface AuthCardProps {
  children: React.ReactNode;
}

export function AuthCard({ children }: AuthCardProps) {
  return (
    <div className="min-h-screen bg-surface-base flex flex-col items-center justify-center px-4 py-8">
      {/* Logo / app name */}
      <div className="mb-6 text-center">
        <span className="text-lg font-bold text-gray-900">Open Roster Scout</span>
      </div>

      {/* Card — full width on mobile, max-width on desktop */}
      <div className="w-full max-w-sm bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-8">
        {children}
      </div>
    </div>
  );
}
